import { FadeOutContainer, FadeOutSpacer, StyledOverflowTypography } from '../components/index.js';
import { SidebarMenuCollapsibleItemContainer } from './styled.js';
import { useSidebarMenuCollapsible } from '../useSidebarMenuCollapsible/index.js';
import { jsx } from 'react/jsx-runtime';

function SidebarMenuCollapsibleItem(props) {
  var label = props.label,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    onClick = props.onClick;
  var _useSidebarMenuCollap = useSidebarMenuCollapsible(),
    mode = _useSidebarMenuCollap.mode,
    collapsibleOpen = _useSidebarMenuCollap.open,
    onChildClick = _useSidebarMenuCollap.onChildClick;
  var handleClick = function handleClick() {
    onClick();
    onChildClick();
  };
  return /*#__PURE__*/jsx(SidebarMenuCollapsibleItemContainer, {
    tabIndex: !collapsibleOpen ? -1 : 0,
    $active: active,
    $isMenuChild: mode === 'menu',
    onClick: handleClick,
    children: /*#__PURE__*/jsx(FadeOutContainer, {
      $minimized: false,
      children: /*#__PURE__*/jsx(FadeOutSpacer, {
        children: /*#__PURE__*/jsx(StyledOverflowTypography, {
          $fontWeight: "regular",
          $fontSize: "medium",
          children: label
        })
      })
    })
  });
}

export { SidebarMenuCollapsibleItem };
